module.exports = __webpack_public_path__ + "img/burger.f9c26ad2.svg";